import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  Button,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InlineLoading,
  Loading
} from 'carbon-components-react'
import './index.scss'

const LoadingModal = ({
  open,
  className,
  modalHeading,
  modalLabel,
  ariaLabel,
  primaryButtonText,
  secondaryButtonText,
  primaryButtonDisabled,
  secondaryButtonDisabled,
  hasScrollingContent,
  hasForm,
  size,
  children,
  onRequestSubmit,
  onRequestClose,
  onSecondarySubmit,
  confirmLoading,
  iconDescription,
  passiveModal,
  confirmLoadingMessage = 'Submitting...',
  loading = false,
  id,
  footerCustom = null,
  preventCloseOnClickOutside
}) => {
  const getDefaultFooter = () => {
    return (
      <>
        <Button
          kind='secondary'
          size='default'
          onClick={onSecondarySubmit || onRequestClose}
          disabled={confirmLoading || secondaryButtonDisabled}
        >
          {secondaryButtonText}
        </Button>
        {confirmLoading && !loading ? (
          <div className='footer-inline-loading'>
            <InlineLoading
              description={confirmLoadingMessage}
              status='active'
            />
          </div>
        ) : (
          <Button
            kind='primary'
            size='default'
            onClick={onRequestSubmit}
            disabled={primaryButtonDisabled}
          >
            {primaryButtonText}
          </Button>
        )}
      </>
    )
  }

  const renderFooter = () => {
    return <ModalFooter>{footerCustom || getDefaultFooter()}</ModalFooter>
  }

  return (
    <ComposedModal
      className={classNames(
        'loading-modal',
        { '.bx--modal-container--xl': size === 'xl' },
        className
      )}
      size={size}
      open={open}
      onClose={onRequestClose}
      id={id}
      preventCloseOnClickOutside={preventCloseOnClickOutside}
    >
      <Loading active={loading} withOverlay />
      <ModalHeader
        label={modalLabel}
        iconDescription={iconDescription}
        aria-label={ariaLabel}
      >
        <h4 className='bx--modal-header__heading'>{modalHeading}</h4>
      </ModalHeader>
      <ModalBody hasScrollingContent={hasScrollingContent} hasForm={hasForm}>
        {children}
      </ModalBody>
      {!passiveModal && renderFooter()}
    </ComposedModal>
  )
}

LoadingModal.propTypes = {
  modalHeading: PropTypes.string,
  modalLabel: PropTypes.string,
  ariaLabel: PropTypes.string,
  primaryButtonText: PropTypes.string,
  primaryButtonDisabled: PropTypes.bool,
  secondaryButtonDisabled: PropTypes.bool,
  secondaryButtonText: PropTypes.string,
  onRequestSubmit: PropTypes.func,
  onRequestClose: PropTypes.func,
  onSecondarySubmit: PropTypes.func,
  open: PropTypes.bool,
  hasScrollingContent: PropTypes.bool,
  hasForm: PropTypes.bool,
  ariaLive: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  iconDescription: PropTypes.string,
  loading: PropTypes.bool,
  confirmLoading: PropTypes.bool,
  confirmLoadingMessage: PropTypes.string,
  passiveModal: PropTypes.bool,
  preventCloseOnClickOutside: PropTypes.bool
}

export default LoadingModal
